import { Controller } from 'react-hook-form';
import {
  DateInput,
  Select,
  PermissionEnum,
  AccountsSelector,
  Account,
  ToggleInput,
  IconTrash,
  AccountingJobTypeEnum,
} from '@ui/src';
import { CreateJobTypes } from './types';

import cn from './styles.module.css';

const CreateJobForm = ({
  control,
  errors,
  activePermissions,
  accountCategories,
  accountsCategoriesLoading,
  accountsIsLoading,
  onSearchAutocomplete,
  setAccountQuery,
  accountsList,
  setAccounts,
  setValue,
  selectedAccountsList,
  setSelectedAccountsList,
  type,
  allAccounts,
  setAllAccounts,
}: CreateJobTypes) => (
  <div className={cn.accountingJobForm}>
    <div className={`${cn.formGroup} ${cn.periodSelector}`}>
      <Controller
        control={control}
        name="periodFrom"
        defaultValue=""
        render={({ field: { value, onChange } }) => (
          <DateInput
            title="Date From"
            value={value}
            placeholder="Select date"
            onChange={(date) => onChange(new Date(date).toISOString())}
            className={`${cn.periodDatePicker} ${
              errors?.periodFrom?.message ? cn.withError : ''
            }`}
            error={errors?.periodFrom?.message}
            disabledAfter={
              type && type === AccountingJobTypeEnum.POST_PROCESSING
                ? new Date()
                : new Date(new Date().setDate(new Date().getDate() - 1))
            }
            withoutCustomSelector
            fullWidth
          />
        )}
      />
    </div>
    <div className={`${cn.formGroup} ${cn.typeSelector}`}>
      <Controller
        control={control}
        name="type"
        defaultValue=""
        render={({ field: { value, onChange, name } }) => (
          <Select
            name={name}
            value={value}
            title="Type"
            error={errors?.type?.message}
            placeholder="Select type"
            list={[
              {
                name: 'Closing balances + Reports + Revaluations',
                value: AccountingJobTypeEnum.BALANCES_LOGS,
                hidden: !activePermissions?.includes(
                  PermissionEnum.REPORTS_ACCOUNTING_JOBS_CREATE_ACTION,
                ),
              },
              {
                name: 'Reports',
                value: AccountingJobTypeEnum.BALANCE_SHEET,
                hidden: !activePermissions?.includes(
                  PermissionEnum.REPORTS_ACCOUNTING_JOBS_CREATE_ACTION,
                ),
              },
              {
                name: 'Revaluations',
                value: AccountingJobTypeEnum.REVALUATION,
                hidden: !activePermissions?.includes(
                  PermissionEnum.REPORTS_ACCOUNTING_JOBS_CREATE_ACTION,
                ),
              },
              {
                name: 'Recalculation of transaction amounts in the base currency + Creation of missing statement items',
                value: AccountingJobTypeEnum.POST_PROCESSING,
                hidden:
                  !activePermissions?.includes(
                    PermissionEnum.REPORTS_ACCOUNTING_JOBS_CREATE_ACTION,
                  ) &&
                  !activePermissions?.includes(
                    PermissionEnum.REPORTS_ACCOUNTING_JOBS_RESTATEMENT_CREATE_ACTION,
                  ),
              },
            ]}
            onChange={onChange}
            fullWidth
          />
        )}
      />
    </div>
    <div className={cn.formGroup}>
      <ToggleInput
        name="allAccounts"
        title="All accounts"
        checked={allAccounts}
        onChange={(e) => setAllAccounts(e.target.checked)}
      />
    </div>
    <div className={cn.formGroup}>
      <AccountsSelector
        title="Account"
        placeholder="Enter name or number..."
        className={cn.selectDebit}
        accounts={accountCategories}
        isLoading={accountsCategoriesLoading}
        accountsIsLoading={accountsIsLoading}
        onSearch={(searchText) => onSearchAutocomplete(searchText)}
        setAccountQuery={setAccountQuery}
        accountsList={(accountsList) || []}
        setAccounts={setAccounts}
        setSelectedAccount={() => {}}
        setSelectedAccountsList={(data: Account[] | string[]) => {
          setSelectedAccountsList(data as Account[]);

          setValue(
            'accountsIds',
            (data as Account[])?.map((item) => item.id),
          );
        }}
        selectedAccountsList={selectedAccountsList}
        fullWidth
        error={errors?.accountsIds?.message}
        disabled={allAccounts}
        multiple
      />
      <Controller
        control={control}
        name="accountsIds"
        render={({ field: { value, name } }) => (
          <input type="hidden" value={value} name={name} />
        )}
      />
    </div>
    {selectedAccountsList && selectedAccountsList?.length > 0 && (
      <div className={cn.selectedAccountsList}>
        <div className={cn.selectedAccountsListTop}>
          <div
            className={cn.selectedAccountsListTopTitle}
          >{`${selectedAccountsList?.length} account${
            selectedAccountsList?.length > 1 ? 's' : ''
          } added`}</div>
          <button
            type="button"
            className={cn.deletAllAccountsButton}
            onClick={() => {
              setValue('accountsIds', []);
              setSelectedAccountsList([]);
            }}
          >
            Delete all
          </button>
        </div>
        {selectedAccountsList?.map((item) => (
          <div className={cn.selectedAccount} key={item.id}>
            <div className={cn.selectedAccountNumber}>{item.fullNumber}</div>
            <div className={cn.selectedAccountDescription}>
              {item.description}
            </div>
            <button
              type="button"
              className={cn.deleteAccountButton}
              onClick={() => {
                const nextSelectedAccount = selectedAccountsList?.filter(
                  (account) => account.id !== item.id,
                );
                setSelectedAccountsList(nextSelectedAccount);
                setValue(
                  'accountsIds',
                  nextSelectedAccount?.map((account) => account.id),
                );
              }}
            >
              <IconTrash />
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default CreateJobForm;
